import { render, staticRenderFns } from "./ProjectManagement.vue?vue&type=template&id=93c1febe&scoped=true&"
import script from "./ProjectManagement.vue?vue&type=script&lang=js&"
export * from "./ProjectManagement.vue?vue&type=script&lang=js&"
import style0 from "./ProjectManagement.vue?vue&type=style&index=0&id=93c1febe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c1febe",
  null
  
)

export default component.exports